import clsx from "clsx";
import React, { ReactElement, useState } from "react";
import { colors } from "../../color";

interface Props {
    icon?: ReactElement | undefined
    label: string
    selectedPrimary?: boolean
    selectedSecondary?: boolean
    onClick: () => void
    type: 'primary' | 'secondary'
    disabled?: boolean
    labelBadge?: string
}

export function Tab(props: Props) {
    const { icon } = props;
    const { label } = props;
    const { selectedPrimary } = props;
    const { selectedSecondary } = props;
    const { onClick } = props;
    const { type } = props;
    const { disabled } = props;
    const { labelBadge } = props;

    const [isHover, setIsHover] = useState(false)

    return (
        <div
            onMouseEnter={() => !disabled && setIsHover(true)}
            onMouseLeave={() => !disabled && setIsHover(false)}
            style={{
                color: (type === 'primary' || type === 'secondary') && isHover ? colors.pas[500] : selectedPrimary && type === 'primary' ? colors.pas[500] : selectedSecondary && type === 'secondary' ? colors.pas[500] : '',
                borderColor: selectedPrimary && type === 'primary' ? colors.pas[500] : '',
                backgroundColor: selectedSecondary && type === 'secondary' ? colors.brandPrimary[100] : ''
            }}
            className={
                clsx("flex flex-row items-center gap-2",
                    {
                        "lg:px-6 px-4 h-[44px] cursor-pointer": type === 'primary',
                        "border-b-2  text-label-md  font-medium": selectedPrimary && type === 'primary',
                        "text-label-md text-brandSecondary-600 font-medium": !selectedPrimary && type === 'primary',
                        "rounded-lg px-3 py-[10px] gap-2 text-label-md font-medium cursor-pointer hover:text-brandPrimary-500": type === 'secondary',
                        "text-brandSecondary-500": !selectedSecondary && type === 'secondary',
                        "cursor-not-allowed opacity-50": disabled
                    }
                )
            }
            onClick={() => !disabled && onClick()}
        >
            {icon && React.cloneElement(icon as ReactElement<any>, { color: isHover || (selectedPrimary || selectedSecondary) ? colors.pas[500] : colors.brandSecondary[500], size: 20 })}
            {label}
            {/* {
                labelBadge &&
                <Badges size={"xs"} label={labelBadge} outline={false} emphasis={true} color={"red"} />
            } */}
        </div>
    )
}